/**
 * Norwegian translations for Vidstack PlyrLayout
 * Based on PlyrLayoutTranslations type
 */

export const NORWEGIAN = {
  // Playback
  Play: 'Spill av',
  Pause: 'Pause',
  Restart: 'Start på nytt',
  Rewind: 'Spol tilbake',
  'Rewind {0}s': 'Spol tilbake {0}s',
  Forward: 'Spol frem',
  'Forward {0}s': 'Spol frem {0}s',
  'Seek forward': 'Søk fremover',
  'Seek backward': 'Søk bakover',

  // Volume
  Mute: 'Demp',
  Unmute: 'Skru på lyd',
  Volume: 'Volum',
  'Increase volume': 'Øk volumet',
  'Decrease volume': 'Reduser volumet',

  // Fullscreen
  'Enter Fullscreen': 'Fullskjerm',
  'Exit Fullscreen': 'Avslutt fullskjerm',

  // Picture-in-Picture
  'Enter PiP': 'Bilde-i-bilde',
  'Exit PiP': 'Avslutt bilde-i-bilde',

  // Captions
  Captions: 'Undertekster',
  'Enable captions': 'Skru på undertekster',
  'Disable captions': 'Skru av undertekster',

  // Settings
  Settings: 'Innstillinger',
  'Go back to previous menu': 'Gå tilbake til forrige meny',
  Speed: 'Hastighet',
  Normal: 'Normal',
  Quality: 'Kvalitet',
  Loop: 'Gjenta',
  Auto: 'Auto',

  // Time
  'Current time': 'Nåværende tid',
  Duration: 'Varighet',
  'Remaining time': 'Gjenstående tid',

  // States
  LIVE: 'DIREKTE',
  'Live broadcast': 'Direktesending',
  Buffered: 'Bufret',
  Played: 'Spilt',

  // Misc
  Download: 'Last ned',
  AirPlay: 'AirPlay',
  Ad: 'Annonse',
  All: 'Alle',
  Audio: 'Lyd',
  Default: 'Standard',
  Disabled: 'Deaktivert',
  Enabled: 'Aktivert',
  End: 'Slutt',
  Reset: 'Tilbakestill',
  Seek: 'Søk',
  Start: 'Start',
}
